export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://192.168.1.26:3000'
export const LCW_DEEP_LINK =
  process.env.REACT_APP_LCW_DEEP_LINK || 'https://lcw.app/request'
